package ai.wagemix.web.screens

import ai.wagemix.logic.wages.WMWageSummary
import ai.wagemix.web.components.WMBandChartModel
import ai.wagemix.web.components.WMBandChartPoint
import ai.wagemix.web.components.WMFormat
import ai.wagemix.web.components.of
import kotlin.math.roundToInt

/*
 * Formatting-only mappings from logic results to component presentation models. No decisions.
 */

fun WMWageSummary.toBandChartModel(): WMBandChartModel = WMBandChartModel.of(
    points = points.map { WMBandChartPoint.of(it.year, it.p10, it.p25, it.median, it.p75, it.p90) },
    lastActualYear = lastActualYear,
    hourly = hourly
)

/** Medians only, for the saved-mix sparkline. */
fun sparklineModel(medians: List<Double>, startYear: Int): WMBandChartModel = WMBandChartModel.of(
    points = medians.mapIndexed { i, m -> WMBandChartPoint.of(startYear + i, null, null, m, null, null) },
    lastActualYear = null,
    hourly = false
)

fun formatWage(value: Double?, hourly: Boolean): String = when {
    value == null -> "—"
    hourly -> WMFormat.hourly(value.toFloat())
    else -> WMFormat.money(value.roundToInt())
}

fun formatWageShort(value: Double?, hourly: Boolean): String = when {
    value == null -> "—"
    hourly -> WMFormat.hourlyWhole(value.toFloat())
    else -> WMFormat.moneyThousands(value.roundToInt())
}

fun formatWageRange(low: Double?, high: Double?, hourly: Boolean): String = when {
    low == null || high == null -> "—"
    hourly -> WMFormat.hourlyRange(low.toFloat(), high.toFloat())
    else -> WMFormat.range(low.roundToInt(), high.roundToInt())
}

fun formatShare(share: Double): String = WMFormat.percent(share * 100)
